<p-toolbar styleClass="footer-toolbar">
  <span>
    <a routerLink ="/"><mat-icon>home</mat-icon></a>
  </span>
</p-toolbar>
